import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class EditorStateService {
  private changeSource = new Subject<void>();
  change$ = this.changeSource.asObservable();

  notifyChange() {
    this.changeSource.next();
  }
}



// WEBPACK FOOTER //
// ./src/app/services/editor-state.service.ts